import React from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';

/**
 * Toggle native fullscreen. Matches presenter header pill buttons (Comments).
 */
function FullscreenToggleButton({
  isFullscreen,
  onClick,
  className = '',
  showLabel = true,
}) {
  const label = isFullscreen ? 'Exit fullscreen' : 'Fullscreen';
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isFullscreen}
      aria-label={label}
      title={label}
      className={[
        'inline-flex shrink-0 items-center justify-center gap-1.5 rounded-full h-9 border px-3 text-sm font-medium shadow-sm transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1',
        isFullscreen
          ? 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100'
          : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900',
        className,
      ].join(' ')}
    >
      {isFullscreen ? (
        <Minimize2 className="h-4 w-4 shrink-0" aria-hidden />
      ) : (
        <Maximize2 className="h-4 w-4 shrink-0" aria-hidden />
      )}
      {showLabel && <span className="hidden sm:inline">{isFullscreen ? 'Exit' : 'Fullscreen'}</span>}
    </button>
  );
}

export default FullscreenToggleButton;
